import * as PIXI from "pixi.js";
import {Sprite} from "../../Core/Sprite";
import {Container} from "../../Core/Container";
import {Dict} from "../../Core/Reflection";
import {IPoint} from "../../Core/Geom";

export class AssemblyItem<T extends string> extends Container {

    readonly slot: T;
    public value = 0;

    readonly sprite = this.addChild(new Sprite());

    constructor(slot: T, value = 0) {
        super();
        this.slot = slot;
        this.value = value;
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        this.sprite.setLayoutTexture(texture, anchorX, anchorY);
    }

    onLayout() {
        if (this.value === 0) {
            const textureName = this.textureName;
            if (textureName) {
                this.value = parseInt(textureName.replace(/^[^\d]+(\d+)$/, "$1"));
            }
        }
    }

    get textureName() {
        return this.sprite.texture.textureCacheIds[0];
    }
}

export class AssemblyBody<T extends string> extends AssemblyItem<T> {

    private limbPositions: Dict<string, IPoint> = {};

    setLimbPosition(slot: T, limb: string, position: IPoint) {
        const key = slot + limb.replace(/\d+/, "");
        if (this.limbPositions[key]) {
            this.limbPositions[key]!.x = position.x;
            this.limbPositions[key]!.y = position.y;
        } else {
            this.limbPositions[key] = {x: position.x, y: position.y};
        }
    }

    getLimbPosition(slot: T, limb: string) {
        return this.limbPositions[slot + limb.replace(/\d+/, "")];
    }
}